module.exports = __webpack_public_path__ + "img/apply-for-rent-2-th.2bb53ba.png";